import { useEffect, useState, useRef } from 'react';

function useSSE(endpoint, hasToken) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [token, setToken] = useState(null);
  const retryTimeout = useRef(null);
  const retryCount = useRef(0);

  const newEventSource = () => {
    const protocol = process.env.REACT_APP_BACKEND_IP === "localhost" ? "http://" : "https://";
    const port = process.env.REACT_APP_BACKEND_IP === "localhost" ? `:${process.env.REACT_APP_BACKEND_PORT}` : "";
    const tokenParam = hasToken && token ? `?token=${token}` : "";

    return new EventSource(`${protocol}${process.env.REACT_APP_BACKEND_IP}${port}/${endpoint}${tokenParam}`);
  };

  useEffect(() => {
    if (hasToken && !token) return;

    let eventSource = newEventSource();

    const connect = () => {
      eventSource.onmessage = (event) => {
        const newData = JSON.parse(event.data);
        setData(newData);
        setError(null);
        retryCount.current = 0;
      };

      eventSource.onerror = () => {
        setError('Connection lost. Trying to reconnect...');
        eventSource.close();

        const delay = Math.min(30000, 1000 * 2 ** retryCount.current); // Exponential backoff (max 30 sec)
        retryCount.current += 1;

        retryTimeout.current = setTimeout(() => {
          eventSource = newEventSource();
          connect();
        }, delay);
      };
    };

    connect();

    return () => {
      eventSource.close();
      if (retryTimeout.current) clearTimeout(retryTimeout.current);
    };

  }, [endpoint, token]);

  return { data:JSON.parse(JSON.stringify(data)), error, setToken };
}

export default useSSE;
